import { BodyS, CaptionBold, DisplayM, HeadingSBold } from 'components/Typography/Typography';
import { translate } from 'components/Translation';
import React, { useMemo } from 'react';
import { makeStyles } from '@material-ui/styles';
import styles from 'assets/jss/material-dashboard-pro-react/components/paymentFormStyle';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';

// @ts-ignore
const useStyles = makeStyles(styles);

interface ISummaryProps {
	numberOfElements?: number;
	elementsText?: string;
	totalAmount: number;
	selectedDonation: types.payment.IDonation | null;
}

const Summary = ({ numberOfElements, elementsText, totalAmount, selectedDonation }: ISummaryProps) => {
	const classes = useStyles();

	const totalAmountWithDonation: string = useMemo(() => {
		if (selectedDonation) {
			return (Number(selectedDonation.value) + Number(totalAmount)).toFixed(3);
		}
		return totalAmount.toFixed(3);
	}, [totalAmount, selectedDonation]);

	return (
		<div className={classes.paymentSummary}>
			<div id="payment-selected-numbers">
				<ConditionalRender
					show={numberOfElements !== undefined}
					onTrue={() => (
						<>
							<div className={classes.paymentSummaryCaption}>
								<BodyS color="secondary-light" disableMargin>
									{elementsText || translate('payments.topup.selectedNumbers')}
								</BodyS>
							</div>
							<DisplayM color="disabled-light" disableMargin>
								{String(numberOfElements)}
							</DisplayM>
						</>
					)}
				/>
			</div>
			<div>
				<div className={classes.paymentSummaryCaption}>
					<BodyS color="secondary-light" disableMargin>
						{translate('payments.topup.totalAmount')}
					</BodyS>
				</div>
				<ConditionalRender
					show={!!selectedDonation}
					onTrue={() => (
						<div className={classes.donationValueWrapper} id="donation-value-wrapper">
							<>
								<DisplayM color="disabled-light" disableMargin inline>
									{String(totalAmount)}
								</DisplayM>
								<HeadingSBold inline color="disabled-light">
									<> {translate('OMR')}</>
								</HeadingSBold>
							</>
							<CaptionBold color="brand-secondary" disableMargin>
								{translate('donations.top.up.card', selectedDonation!.value)}
							</CaptionBold>
						</div>
					)}
				/>
				<div id="payment-total-amount">
					<DisplayM inline>{totalAmountWithDonation}</DisplayM>
					<HeadingSBold inline>
						<> {translate('OMR')}</>
					</HeadingSBold>
				</div>
			</div>
		</div>
	);
};

export default Summary;
